export const arrayRange = (start: number, stop: number, step: number = 1) => {
  return Array.from(
    {
      length: (stop - start) / step + 1
    },
    (value, index) => start + index * step
  )
}

export const repeat = (length: number, whatTo: any) => {
  const arr = []
  for (let i = 0; i < length; i++) {
    arr.push(whatTo)
  }
  return arr
}

export const isArrayNonEmpty = (array: string[]) => {
  for (let i = 0; i < array.length; i++) {
    if (typeof array[i] === 'string' && array[i].trim() !== '') {
      return true
    }
  }
  return false
}

export const unique = (array: string[]) => [...new Set(array)]

/**
 * Calculates de middle index from array of N length
 * Important: array must be previously sorted
 * [1, 2, 3, 4, 5] -> odd -> 2 as middle index
 * [1, 2, 3, 4] -> even -> inmediate previous value: 1 as middle index
 * @param array any
 * @returns number
 */
export const middleIndex = (arr: Array<any>) => {
  if (arr.length === 0) {
    // empty
    return -1
  }

  const middleIndex = Math.floor(arr.length / 2)

  // odd, return the middle index value
  if (arr.length % 2 !== 0) {
    return middleIndex
  }

  return Math.floor(middleIndex) // even, returns the inmediate previous value
}
